import { useState } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export default function NavBar() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  if (!user) return null

  const handleLogout = async () => {
    await logout()
    setOpen(false)
    navigate('/')
  }

  const isAdmin = user.role === 'admin'

  const navLinkClass = ({ isActive }) =>
    `px-3 py-2 rounded-md text-sm font-medium transition ${
      isActive ? 'bg-brand-50 text-brand-700' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
    }`

  return (
    <nav className="bg-white border-b border-slate-200 sticky top-0 z-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-14">
          <Link to="/" className="flex items-center gap-2 font-semibold text-slate-900">
            <span className="w-7 h-7 rounded bg-brand-600 text-white text-xs flex items-center justify-center">B</span>
            <span className="hidden sm:inline">Brooklinen Services </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            <NavLink to="/" end className={navLinkClass}>Home</NavLink>
            <NavLink to="/trade_applications" className={navLinkClass} title="Trade & Hospitality applications">Applications</NavLink>
            {isAdmin && <NavLink to="/admin/users" className={navLinkClass}>Users</NavLink>}
            {isAdmin && <NavLink to="/admin/email_templates" className={navLinkClass}>Templates</NavLink>}
            {isAdmin && <NavLink to="/admin/activity" className={navLinkClass}>Activity</NavLink>}
          </div>

          <div className="hidden lg:flex items-center gap-3 min-w-0">
            <span className="text-sm text-slate-600 flex items-center gap-1 min-w-0">
              <span className="truncate max-w-[180px]" title={user.email}>{user.email}</span>
              <span className="shrink-0 inline-block text-xs px-1.5 py-0.5 rounded bg-slate-100 text-slate-600 align-middle">
                {user.role}
              </span>
            </span>
            <button onClick={handleLogout} className="btn-secondary shrink-0">Sign out</button>
          </div>

          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden inline-flex items-center justify-center p-2 rounded-md text-slate-600 hover:text-slate-900 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-brand-500"
            aria-label="Toggle menu"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {open ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {open && (
          <div className="lg:hidden py-2 border-t border-slate-200">
            <NavLink to="/" end onClick={() => setOpen(false)} className={navLinkClass}>Home</NavLink>
            <NavLink to="/trade_applications" onClick={() => setOpen(false)} className={navLinkClass}>Trade &amp; Hospitality applications</NavLink>
            {isAdmin && (
              <NavLink to="/admin/users" onClick={() => setOpen(false)} className={navLinkClass}>Users</NavLink>
            )}
            {isAdmin && (
              <NavLink to="/admin/email_templates" onClick={() => setOpen(false)} className={navLinkClass}>Email templates</NavLink>
            )}
            {isAdmin && (
              <NavLink to="/admin/activity" onClick={() => setOpen(false)} className={navLinkClass}>Activity</NavLink>
            )}
            <div className="mt-2 pt-2 border-t border-slate-100 flex flex-col gap-2">
              <span className="px-3 text-sm text-slate-600">{user.email} ({user.role})</span>
              <button onClick={handleLogout} className="btn-secondary mx-3">Sign out</button>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}
